// retool/erp/ops/get-bulk-orders-for-approval

import { createSlice } from '@reduxjs/toolkit';

import { getOpsVendorPendingOrders, confirmOpsVendorPendingOrders } from '../../apis';

export const OpsVendorPendingOrders = createSlice({
    name: 'opsVendorPendingOrders',
    initialState: {
        opsVendorPendingOrdersIsLoading: false,
        confirmOpsVendorPendingOrdersIsLoading: false,
        data : [],
        error: '',
        selectedOrders: [],
        ordersConfirmed: false,
        masterCheckbox: false
    },

    reducers: {
        // selectOrder: (state, action) => {
        //     return {
        //         ...state,
        //         selectedOrders: [
        //             ...state.selectedOrders,
        //             ...action.payload
        //         ]
        //     }
        // },
        // deSelectOrder: (state, action) => {
        //     return {
        //         ...state,
        //         selectedOrders: (state.selectedOrders.filter(selectedOrder => selectedOrder !== action.payload))
        //     }
        // },
        // deSelectAllOrder: (state, action) => {
        //     return {
        //         ...state,
        //         selectedOrders: []
        //     }
        // },
        // masterCheckbox: (state, action) => {
        //     return {
        //         ...state,
        //         masterCheckbox: action.payload
        //     }
        // },
        updateSelectedOrders: (state, action) => {
            return {
                ...state,
                selectedOrders: action.payload
            }
        },
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getOpsVendorPendingOrders.pending, (state, action) => {
            state.opsVendorPendingOrdersIsLoading = true;
        })
        builder.addCase(getOpsVendorPendingOrders.fulfilled, (state, action) => {
            state.opsVendorPendingOrdersIsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getOpsVendorPendingOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.opsVendorPendingOrdersIsLoading = false;
        })
        builder.addCase(confirmOpsVendorPendingOrders.pending, (state, action) => {
            state.confirmOpsVendorPendingOrdersIsLoading = true;
        })
        builder.addCase(confirmOpsVendorPendingOrders.fulfilled, (state, action) => {
            state.confirmOpsVendorPendingOrdersIsLoading = true;
            state.ordersConfirmed = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(confirmOpsVendorPendingOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.confirmOpsVendorPendingOrdersIsLoading = false;
        })
    }
})

// export const { selectOrder, deSelectOrder, deSelectAllOrder, masterCheckbox, updateSelectedOrders } = OpsVendorPendingOrders.actions
export const { updateSelectedOrders, clearErrorState } = OpsVendorPendingOrders.actions

export default OpsVendorPendingOrders.reducer